export const blockIconsSocialPublic = (
	<span className='material-symbols-outlined'>public</span>
);
